import { render, staticRenderFns } from "./AssessmentEmpty.vue?vue&type=template&id=5e5855a8&"
import script from "./AssessmentEmpty.vue?vue&type=script&lang=js&"
export * from "./AssessmentEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports